var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},_vm.$listeners),[_c('path',{attrs:{"fill":"#6aa84f","d":"M12 2A10 10 0 002 12a10 10 0 0010 10 10 10 0 0010-10A10 10 0 0012 2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }